"use strict";
/** @jsx jsx */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const react_1 = __importDefault(require("react"));
const styled_react_1 = require("./styled-react");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Breadcrumb = ({ separator, gap, colorSelected, color, hoverColor, children, }) => (core_1.jsx("div", { css: styled_react_1.breadcrumbDynamicStyle(gap) }, react_1.default.Children.map(children, (c, i) => react_1.default.cloneElement(c, {
    separator,
    colorSelected,
    color,
    hoverColor,
    gap,
    isLastChild: c.props.isLastChild || i === children.length - 1
}))));
Breadcrumb.defaultProps = {
    separator: '/',
    gap: styles_scss_1.default.xs,
    color: styles_scss_1.default.black,
    colorSelected: styles_scss_1.default.primary,
    hoverColor: styles_scss_1.default.primaryHover,
    children: undefined
};
const BreadcrumbItem = ({ key, isCurrentPage, isLastChild, children, color, colorSelected, hoverColor, separator, gap, }) => (core_1.jsx("div", { key: key, css: styled_react_1.breadcrumbItemDynamicStyle(isCurrentPage, color, colorSelected) },
    typeof children !== 'string'
        ? react_1.default.cloneElement(children, {
            color: isCurrentPage ? colorSelected : color,
            hoverColor: isCurrentPage ? hoverColor : color,
        })
        : children,
    !isLastChild && core_1.jsx("span", { css: styled_react_1.breadcrumbSeparatorDynamicStyle(gap, color) }, separator)));
BreadcrumbItem.defaultProps = {
    isCurrentPage: false,
    isLastChild: false,
    children: undefined,
    color: undefined,
    colorSelected: undefined,
    hoverColor: undefined,
    separator: undefined,
    gap: undefined,
    key: undefined,
};
Breadcrumb.BreadcrumbItem = BreadcrumbItem;
exports.default = Breadcrumb;
